import { ReactToExerciseEventType, StartExercise, UpdateObjective } from "Phaser/EventBus";
import Tutorial, { ChapterType, ExerciseScene } from "Types/ExerciseData";
import { AddEventsAndMergeTimestamps, Timestamps } from "Utils/ChaptersToTimestamps";
import timestamps from "./level8.json";

// This is still using the old JSON way of defining levels
const Level8: Tutorial = {
  level: 8,
  end: '2:04',
  videoUrl: 'level-8.mp4',
  sections: [
    {
      chapters: [
        {
          title: 'F in the Treble Clef',
          start: '0:0',
          data: [ChapterType.Lecture]
        },
        {
          title: 'F on the Keyboard',
          start: '0:13',
          data: [ChapterType.Lecture]
        },
        {
          title: 'Find F',
          start: '0:24',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.PianoScene,
                {
                  start: 'A0',
                  end: 'C8',
                  transition: 'Dissolve',
                  textPromptPosition: 'Top',
                  objectives: [
                    {
                      text: 'Play F on your keyboard.',
                      target: 'F4',
                    },
                  ],
                },
              ],
              events: [
              ],
            },
          ],
        }
      ]
    },
    {
      chapters: [
        {
          title: 'Playing with the 4th Finger',
          start: '0:30',
          data: [ChapterType.Lecture]
        },
        {
          title: 'Playing F',
          start: '0:34',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.NoTimeExercise,
                {
                  centre_align_horizontal: false,
                  padding_x: 180,
                  objectives: [
                    {
                    },
                  ],
                },
              ],
              events: [
              ],
            }
          ]
        },
        {
          title: '4th Finger Technique',
          start: '0:42',
          data: [ChapterType.Lecture]
        },
        {
          title: 'Alternating Fingers',
          start: '1:07',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.NoTimeExercise,
                {
                  centre_align_horizontal: true,
                  padding_x: 700,
                  firstObjectiveAppearDelay: 1500,
                  objectives: [
                    {
                    },
                    {
                    },
                    {
                    }
                  ],
                },
              ],
              events: [
              ],
            }
          ]
        },
        {
          title: 'Playing in Time',
          start: '1:26',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.StaffExercise,
                {
                  firstObjectiveAppearDelay: 500,
                  objectives: [
                    {
                    },
                    {
                    },
                  ],
                },
              ],
              events: [
              ],
            }
          ]
        }
      ]
    },
    {
      chapters: [
        {
          title: 'Using Both Hands',
          start: '1:42',
          data: [ChapterType.Lecture]
        },
        {
          title: 'Alternating Hands',
          start: '1:48',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.StaffExercise,
                {
                  firstObjectiveAppearDelay: 500,
                  objectives: [
                    {
                    },
                    {
                    },
                  ],
                },
              ],
              events: [
              ],
            }
          ]
        }
      ]
    }
  ]
};
export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level8);
